module.exports = __webpack_public_path__ + "static/media/icon_forbes.28e02339.png";